<template>
  <transition leave-active-class="duration-500">
    <!-- <span class="z-30 rounded-full shadow-lg bottom-8 left-8">
      <button
        class="text-center bg-gray-200 rounded-full shadow-lg focus:outline-none hover:bg-gray-100"
        @click="$emit('toogleSideOver')"
      >
        <svg
          class="relative flex-shrink-0 w-6 h-6 m-2 text-gray-600"
          stroke="currentColor"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
          />
        </svg>
      </button>
    </span>-->
    <div class="fixed inset-0 z-20 overflow-hidden" v-show="open">
      <div class="absolute inset-0 overflow-hidden">
        <section class="absolute inset-y-0 left-0 flex max-w-full pr-10">
          <!--
        Slide-over panel, show/hide based on slide-over state.

        Entering: "transform transition ease-in-out duration-500 sm:duration-700"
          From: "translate-x-full"
          To: "translate-x-0"
        Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
          From: "translate-x-0"
          To: "translate-x-full"
          -->
          <transition
            enter-active-class="transition duration-500 ease-in-out transform sm:duration-700"
            enter-class="-translate-x-full"
            enter-to-class="translate-x-0"
            leave-active-class="transition duration-500 ease-in-out transform sm:duration-700"
            leave-class="translate-x-0 "
            leave-to-class="-translate-x-full"
          >
            <div class="w-screen max-w-md relative" v-show="open">
              <div
                class="flex flex-col h-full overflow-y-auto bg-gray-700 shadow-xl"
              >
                <!-- <header class="px-4 sm:px-6 h-12 flex items-center justify-between">
                  <div class="flex items-center justify-between space-x-3 w-full">
                    <logo></logo>
                    <h2 class="text-lg font-semibold leading-7 text-gray-300">Editor</h2>
                    <div class="flex items-center h-7">
                      <button
                        aria-label="Close panel"
                        @click="$emit('close')"
                        class="text-gray-400 transition duration-150 ease-in-out hover:text-gray-500"
                      >
                        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </header>-->
                <div
                  class="absolute top-1/2 right-0 flex items-center z-50 -mr-5 bg-gray-600 p-2 rounded-full shadow-lg"
                >
                  <button
                    aria-label="Close panel"
                    @click="$emit('close')"
                    class="text-gray-400 transition duration-150 ease-in-out hover:text-gray-500"
                  >
                    <svg
                      class="w-8 h-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M10 19l-7-7m0 0l7-7m-7 7h18"
                      />
                    </svg>
                  </button>
                </div>
                <div class="">
                  <!-- Replace with your content -->
                  <!-- <div class="absolute inset-0 px-4 sm:px-6">
                <div class="h-full border-2 border-gray-200 border-dashed"></div>
                  </div>-->
                  <slot></slot>

                  <!-- /End replace -->
                </div>
              </div>
            </div>
          </transition>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
//import Logo from "@/components/Logo";
export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    // Logo,
  },
};
</script>

<style lang="scss" scoped>
</style>